import DateFnsUtils from "@date-io/date-fns";
import {
  KeyboardDatePicker,
  type KeyboardDatePickerProps,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import React from "react";
import HelperText, { type ErrorMessage } from "./HelperText";

export type DatePickerProps = Omit<KeyboardDatePickerProps, "error"> & {
  error?: string | ErrorMessage;
  /**
   * Force the helper row not to be displayed.
   * This will suppress the any errors from being shown but will set the height of the component to be only
   * the height of the input; rather than including whitespace for the error/helper message to render in.
   */
  hideHelper?: boolean;
  format?: string;
};

// Warning - this gives you dates with a time portion of right now, and not just a yyyy-mm-dd or zeroed date.
function DatePicker(
  {
    variant = "inline",
    error,
    hideHelper,
    format,
    autoOk = true,
    disableToolbar = true,
    ...restProps
  }: DatePickerProps,
  ref: React.Ref<HTMLDivElement>,
): React.ReactElement {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        {...restProps}
        ref={ref}
        variant={variant}
        autoOk={autoOk}
        format={format ?? "dd/MM/yyyy"} // FIXME: get from react-intl
        id={restProps.name}
        disableToolbar={disableToolbar}
        KeyboardButtonProps={{
          "aria-label": "change date",
        }}
        InputLabelProps={{
          htmlFor: restProps.name,
          "aria-labelledby": restProps.name,
        }}
        error={!!error}
        helperText={
          hideHelper ? null : (
            <HelperText error={error}>{restProps.helperText}</HelperText>
          )
        }
      />
    </MuiPickersUtilsProvider>
  );
}

export default React.forwardRef(DatePicker);
